import { render, staticRenderFns } from "./TabDataPreview.vue?vue&type=template&id=39113458&scoped=true&"
import script from "./TabDataPreview.vue?vue&type=script&lang=js&"
export * from "./TabDataPreview.vue?vue&type=script&lang=js&"
import style0 from "./TabDataPreview.vue?vue&type=style&index=0&id=39113458&prod&lang=scss&scoped=true&"
import style1 from "./TabDataPreview.vue?vue&type=style&index=1&id=39113458&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39113458",
  null
  
)

export default component.exports